import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import {
  ActionRow,
  Button,
} from '@openedx/paragon';

import messages from './messages';

const ModalFooter = ({
  onSubmit,
  close,
  buttonText,
}) => {
  const { formatMessage } = useIntl();
  return (
    <ActionRow>
      <Button variant="tertiary" onClick={close}>
        {formatMessage(messages.cancelButtonText)}
      </Button>
      <Button onClick={onSubmit}>
        {buttonText}
      </Button>
    </ActionRow>
  );
};

ModalFooter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  buttonText: PropTypes.node.isRequired,
};

export default ModalFooter;
